<template>
    <div id="order_history_page" style="min-width: 100vw; width: fit-content;">
    <div class="d-flex" style="min-height: 42vw; width: fit-content">
        <div class="flex-item item_2_space item_space_border_left" style="min-width: 5vw;max-width: 5vw;"></div>
        <div class="flex-item item_8" style="margin-top: 10px;">
            <div style="width: max-content;" id="main_slider_div">
                <div class="d-flex" style="user-select: none;">
                    <div class="flex-item section" style="display:flex; text-align: left; width: 300px;" id="non_processed_button">Текущий год <span id="nowYearRequests" class="summaryRequests">3</span> </div>
                    <div class="flex-item section" style="display:flex; text-align: left;" id="in_pipeline_button">В архиве <span id="archiveRequests" class="summaryRequests">9999</span></div>
                </div>
                <div class="d-flex" style="margin-bottom: 10px; margin-top: 10px;">
                    <div class="flex-item item_8" id="parent" style="background: #E0E0E0; height: 4px;">
                        <div id="child" style="background: #4BACE3; height: 100%; width: 100px; margin-left: 30px;"></div>
                    </div>
                </div>
            </div>
            <div class="d-flex" id="order_types" style="margin-top: 20px; width: 90vw; min-width: fit-content;">
                <span id="superviser__control" class="superviser__control" v-on:click="reRender($event)">
                    <label id="filter__head" class="filter__head">
                        <img v-on:click="flexFilters()" src="../assets/IMGS/SVG/filterIco.svg">
                        <a id="filter_zone_item" v-on:click="reFiltering()" style="cursor: pointer; color: #FF8A90; border-bottom: 2.9px dotted #FF8A90;">Очистить</a>
                    </label>
                    <label id="fliter__status" style='' class="fliter__status">
                        <a class="head__text">Статус заказа</a>
                        <div id="order_status_select_box" class="select-box custom-select">
                            <div class="myarrow"></div>
                            <div id="order_status_selected" class="selected_option" v-on:click.stop="tools.selectedOpenClose('order_status')">
                                <p id="order_status" class="selected_text">Любой</p>
                                <p id="order_status_index" class="selected_hidden_index">-1</p>
                            </div>
                            <div id="order_status_options" class="options" v-on:click.stop="reRender()">
                                <div id="order_status_option1" class="option" v-on:click="tools.selectOptionsChoose('order_status', 1, 4)">
                                    <p id="order_status_option1_text" class="option_text">Любой</p>
                                </div>
                                <div id="order_status_option2" class="option" v-on:click="tools.selectOptionsChoose('order_status', 2, 4)">
                                    <p id="order_status_option2_text" class="option_text">Выполнен</p>
                                </div>
                                <div id="order_status_option3" class="option" v-on:click="tools.selectOptionsChoose('order_status', 3, 4)">
                                    <p id="order_status_option3_text" class="option_text">Отмена</p>
                                </div>
                                <div id="order_status_option4" class="option" v-on:click="tools.selectOptionsChoose('order_status', 4, 4)">
                                    <p id="order_status_option4_text" class="option_text">Отказ</p>
                                </div>
                            </div>
                        </div>
                    </label>
                    <label id="filter__time" class="filter__time">
                        <a class="head__text">Дата и время</a>
                        <span style="display: flex; flex-flow:column; justify-content: center; align-items: center;">
                            <ul class="time__list">
                                <label style="width: 35%; height: 100%;" v-on:click="setNowDay()" class="check__container__radio">
                                    <input id='date1' type="radio" name="radio_date">
                                    <div class="background_checkradio date_check"><span style="padding-left: 5px; padding-right:5px;">Сегодня</span></div>
                                </label>
                                <label style="width:35%; height: 100%;" v-on:click="setLastWeek()" class="check__container__radio">
                                    <input id='date2' type="radio" name="radio_date">
                                    <div class="background_checkradio date_check"><span style="padding-left: 5px; padding-right:5px;">Неделя</span></div>
                                </label>
                                <label style="width: 35%; height: 100%;" v-on:click="setNowMonth()" class="check__container__radio">
                                    <input id='date3' type="radio" name="radio_date">
                                    <div class="background_checkradio date_check"><span style="padding-left: 5px; padding-right:5px;">Месяц</span></div>
                                </label>
                            </ul>
                            <div id="" class="time__back">
                                <label for='first__date' class="date__container">
                                    <input id="first__date" v-on:keyup="tools.inputDateKeyUp('first__date')" v-on:blur="tools.inputDateLoseFocus('first__date')"
                                        type="date" class="date-picker" pattern="(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012])" style="padding-right: 0px;">
                                    <input id="second__date" v-on:keyup="tools.inputDateKeyUp('first__date')" v-on:blur="tools.inputDateLoseFocus('first__date')"
                                        type="date" class="date-picker" pattern="(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012])" style="padding-right: 0px;">
                                </label>
                                <label for='first__time' class="date__container">
                                    <input style="padding-right: 0px;" id="first__time" v-on:click="getNowDate('first__time')" type="time" class="date-picker" >
                                    <input style="padding-right: 0px;" id="second__time" v-on:click="getNowDate('second__time')" type="time" class="date-picker" >
                                </label>
                            </div>
                        </span>
                    </label>
                    <label id="filter__type" class="filter__type" for="">
                        <a class="head__text">Вид услуги</a>
                        <label for='veh__check' class="type__list">
                            <label class="check__container__radio ">
                                <input id='veh__check_1' class="svg_states" type="radio" name="radio_veh" checked>
                                <img class="patient-icon default-icon" style="height:17px;width:19px" src="../assets/IMGS/SVG/car/car.svg">
                                <img class="patient-icon hover-icon" style="height:17px;width:19px" src="../assets/IMGS/SVG/car/car_hover.svg">
                                <img class="patient-icon checked-icon" style="height:17px;width:19px" src="../assets/IMGS/SVG/car/car_checked.svg">
                                <img class="patient-icon checked-hover-icon" style="height:17px;width:19px" src="../assets/IMGS/SVG/car/car_checked_hover.svg">
                                <!-- <img class="checkmark_img" src="../assets/IMGS/SVG/car.svg"> -->
                                <div class="background_checkradio"></div>
                            </label>
                            <label class="check__container__radio">
                                <input id='veh__check_2' class="svg_states" type="radio" name="radio_veh">
                                <img class="patient-icon default-icon" style="height:18px;width:16px" src="../assets/IMGS/SVG/railway/railway.svg">
                                <img class="patient-icon hover-icon" style="height:18px;width:16px" src="../assets/IMGS/SVG/railway/railway_hover.svg">
                                <img class="patient-icon checked-icon" style="height:18px;width:16px" src="../assets/IMGS/SVG/railway/railway_checked.svg">
                                <img class="patient-icon checked-hover-icon" style="height:18px;width:16px" src="../assets/IMGS/SVG/railway/railway_checked_hover.svg">
                                <!-- <img class="checkmark_img" src="../assets/IMGS/SVG/railway.svg"> -->
                                <div class="background_checkradio"></div>
                            </label>
                            <label class="check__container__radio">
                                <input id='veh__check_3' class="svg_states" type="radio" name="radio_veh">
                                <img class="patient-icon default-icon" style="height:18px;width:18px" src="../assets/IMGS/SVG/airplane/airplane.svg">
                                <img class="patient-icon hover-icon" style="height:18px;width:18px" src="../assets/IMGS/SVG/airplane/airplane_hover.svg">
                                <img class="patient-icon checked-icon" style="height:18px;width:18px" src="../assets/IMGS/SVG/airplane/airplane_checked.svg">
                                <img class="patient-icon checked-hover-icon" style="height:18px;width:18px" src="../assets/IMGS/SVG/airplane/airplane_checked_hover.svg">
                                <!-- <img class="checkmark_img" src="../assets/IMGS/SVG/airplane.svg"> -->
                                <div class="background_checkradio"></div>
                            </label>
                            <label class="check__container__radio">
                                <input id='veh__check_4' class="svg_states" type="radio" name="radio_veh">
                                <img class="patient-icon default-icon" style="height:17px;width:30px" src="../assets/IMGS/SVG/boat/boat.svg">
                                <img class="patient-icon hover-icon" style="height:17px;width:30px" src="../assets/IMGS/SVG/boat/boat_hover.svg">
                                <img class="patient-icon checked-icon" style="height:17px;width:30px" src="../assets/IMGS/SVG/boat/boat_checked.svg">
                                <img class="patient-icon checked-hover-icon" style="height:17px;width:30px" src="../assets/IMGS/SVG/boat/boat_checked_hover.svg">
                                <!-- <img class="checkmark_img" src="../assets/IMGS/SVG/boat.svg"> -->
                                <div class="background_checkradio"></div>
                            </label>
                        </label>
                        <label for='type__check' class="type__back">
                            <div class="container__type">
                                <label class="checkbox">
                                    <div class="check__container">
                                        <input id='type__check_1' type="radio" name="radio_type" checked>
                                        <span class="checkmark"></span>
                                    </div>
                                    <a class="checkmark_text" style="width: 90px;font-size: 13px;">Все услуги</a>
                                </label>
                                <label class="checkbox">
                                    <div class="check__container">
                                        <input id='type__check_2' type="radio" name="radio_type">
                                        <span class="checkmark"></span>
                                    </div>
                                    <a class="checkmark_text" style="width: 90px;font-size: 13px;">Сан. перевозка</a>
                                </label>
                                <label class="checkbox">
                                    <div class="check__container">
                                        <input id='type__check_3' type="radio" name="radio_type">
                                        <span class="checkmark"></span>
                                    </div>
                                    <a class="checkmark_text" style="width:120px;font-size: 13px;">Скорая помощь</a>
                                </label>
                                <label class="checkbox">
                                    <div class="check__container">
                                        <input id='type__check_4' type="radio" name="radio_type">
                                        <span class="checkmark"></span>
                                    </div>
                                    <a class="checkmark_text" style="width: 90px;font-size: 13px;">Реанимация</a>
                                </label>
                            </div>
                        </label>
                    </label>
                    <label id="filter__patient" class="filter__patient" for="">
                        <a class="head__text">Пациент</a>
                        <form class="container__patient">
                            <label style="width: 77px;"  class="check__container__radio">
                                <input id='patient__check_1' class="svg_states" type="checkbox" name="checkbox">
                                <img class="patient-icon default-icon" style="height:18px;width:13px" src="../assets/IMGS/SVG/invalid/invalid.svg">
                                <img class="patient-icon hover-icon" style="height:18px;width:13px" src="../assets/IMGS/SVG/invalid/invalid_hover.svg">
                                <img class="patient-icon checked-icon" style="height:18px;width:13px" src="../assets/IMGS/SVG/invalid/invalid_checked.svg">
                                <img class="patient-icon checked-hover-icon" style="height:18px;width:13px" src="../assets/IMGS/SVG/invalid/invalid_checked_hover.svg">
                                <!-- <img class="checkmark_img" src="../assets/IMGS/SVG/invalidPeople.svg"> -->
                                <div class="background_checkradio"></div>
                            </label>
                            <a class="item__split"></a>
                            <label style="width: 77px;"   class="check__container__radio">
                                <input id='patient__check_2' class="svg_states" type="checkbox" name="checkbox">
                                <img class="patient-icon default-icon" style="height:18px;width:10px" src="../assets/IMGS/SVG/pregnant/pregnant.svg">
                                <img class="patient-icon hover-icon" style="height:18px;width:10px" src="../assets/IMGS/SVG/pregnant/pregnant_hover.svg">
                                <img class="patient-icon checked-icon" style="height:18px;width:10px" src="../assets/IMGS/SVG/pregnant/pregnant_checked.svg">
                                <img class="patient-icon checked-hover-icon" style="height:18px;width:10px" src="../assets/IMGS/SVG/pregnant/pregnant_checked_hover.svg">
                                <!-- <img class="checkmark_img" src="../assets/IMGS/SVG/pregnantPeople.svg"> -->
                                <div class="background_checkradio"></div>
                            </label>
                            <a class="item__split"></a>
                            <label style="width: 77px;"  class="check__container__radio">
                                <input id='patient__check_3' class="svg_states" type="checkbox" name="checkbox">
                                <img class="patient-icon default-icon" style="height:17px;width:21px" src="../assets/IMGS/SVG/child/child.svg">
                                <img class="patient-icon hover-icon" style="height:17px;width:21px" src="../assets/IMGS/SVG/child/child_hover.svg">
                                <img class="patient-icon checked-icon" style="height:17px;width:21px" src="../assets/IMGS/SVG/child/child_checked.svg">
                                <img class="patient-icon checked-hover-icon" style="height:17px;width:21px" src="../assets/IMGS/SVG/child/child_checked_hover.svg">
                                <!-- <img class="checkmark_img" src="../assets/IMGS/SVG/child.svg"> -->
                                <div class="background_checkradio"></div>
                            </label>
                        </form>
                    </label>
                    <label id="filter__region" class="filter__region">
                        <div class="container__region">
                            <a class="region__text">Только мой регион</a>
                            <div class="container__checkbox">
                                <input class="toggle__checkbox" type="checkbox" id="toggle_region"/>
                                <div class="toggle__container">
                                    <label class='item__toggle' for="toggle_region"></label>
                                </div>
                            </div>
                        </div>
                    </label>
                    <label id="filter__adress" class="filter__adress">
                        <div class="container__filter">
                            <div class="container-1">
                                <span class="icon"><i class="search__icon"></i></span>
                                <input type="search" id="search_adress" list="search_adress_datalist" placeholder="Адрес" />
                            </div>
                        </div>
                    </label>
                </span>
                <div class="d-flex" id="non_processed_block" style=" width: 100%; color: #747474;">
                    <div class="flex-item item_6" style="padding-left: 10px; flex-grow: 6;">
                        <div
                            style="flex-direction: row; display: flex; text-align: left; font-weight: 400; font-size: 12px; line-height: 16px; margin-bottom: 10px; padding: 15px;">
                            <div style="width: 5%;">No / Время</div>
                            <div style="width: 15%;">Когда</div>
                            <div style="width: 30%;">Откуда/Куда</div>
                            <div style="width: 30%;">Пациент/Транспорт</div>
                            <div style="width: 5%; text-align: center;">Кол-во</div>
                        </div>
                        <div v-if="!has_loaded_once" class="loading_text">
                            Данные загружаются, пожалуйста, подождите
                        </div>
                        <div v-else id="non_processed_orders">
                            <div v-for="order in new_orders" :key="'non_processed_orders_element'+order.id" :id="'non_processed_orders_element'+order.id">
                                <span class="superviser__history_item">
                                    <!--{{ order.comment }}-->
                                    <div class="container__history">
                                        <div class="container__itemID">
                                            <template v-if="order.is_return == false">
                                                <div style='padding-bottom: 6px;' class="itemID">{{ order.id }}</div>
                                                <div class="itemID__time">{{ order.time }}</div>
                                            </template>
                                            <template v-else>
                                                <div style='padding-bottom: 6px;' class="itemID">{{ order.id }}</div>
                                                <div style='padding-bottom: 28px;' class="itemID__time">{{ order.time }}</div>
                                            </template>
                                        </div>
                                        <div class="container__date">
                                            <template v-if="order.is_return == false">
                                                <div style='padding-bottom: 28px;' class="date__item">{{ order.datetime_from }}</div>
                                            </template>
                                            <template v-else-if="order.is_wait == true">
                                                <div style='padding-bottom: 56px;' class="date__item">{{ order.datetime_from }}</div>
                                            </template>
                                            <template v-else>
                                                <div style='padding-bottom: 34px;' class="date__item">{{ order.datetime_from }}</div>
                                                <div class="date__item">{{ order.datetime_to }}</div>
                                            </template>
                                        </div>
                                        <div class="container__place">
                                            <template v-if="order.is_return == false">
                                                <div style='padding-bottom: 6px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_r.svg"><span class="place__text">{{ order.place_from }}</span></div>
                                                <div style='padding-bottom: 6px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_r.svg"><span class="place__text">{{ order.place_to }}</span></div>
                                            </template>
                                            <template v-else>
                                                <div style='padding-bottom: 6px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_r.svg"><span class="place__text">{{ order.place_from }}</span></div>
                                                <div style='padding-bottom: 6px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_r.svg"><span class="place__text">{{ order.place_to }}</span></div>
                                                <div style='padding-bottom: 0px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_l.svg"><span class="place__text">{{ order.place_from }}</span></div>
                                            </template>
                                        </div>
                                        <div class="container__patientHistoryOrdHis">
                                            <template v-if="order.is_return == false">
                                                <div style='padding-bottom: 6px;' class="patient__item">
                                                    <img v-if="order.is_invalid" style='margin-right: 10px;margin-left:3px;' class="green-img" src="../assets/IMGS/SVG/invalidPeople.svg">
                                                    <img v-if="order.is_child" style='margin-right: 10px;' class="green-img" src="../assets/IMGS/SVG/child.svg">
                                                    <img v-if="order.is_pregnant" style='margin-right: 10px;' class="green-img" src="../assets/IMGS/SVG/pregnantPeople.svg">
                                                    {{ order.patient_info }}
                                                </div>
                                                <div class="patient__item"><img class="green-img" src="../assets/IMGS/SVG/car.svg">{{ order.transport }}</div>
                                            </template>
                                            <template v-else>
                                                <div style='padding-bottom: 6px;' class="patient__item">
                                                    <img v-if="order.is_invalid" style='margin-right: 10px;margin-left:3px;' class="green-img" src="../assets/IMGS/SVG/invalidPeople.svg">
                                                    <img v-if="order.is_child" style='margin-right: 10px;' class="green-img" src="../assets/IMGS/SVG/child.svg">
                                                    <img v-if="order.is_pregnant" style='margin-right: 10px;' class="green-img" src="../assets/IMGS/SVG/pregnantPeople.svg">
                                                    {{ order.patient_info }}
                                                </div>
                                                <div style='padding-bottom: 28px;' class="patient__item"><img class="green-img" src="../assets/IMGS/SVG/car.svg">{{ order.transport }}</div>
                                            </template>
                                        </div>
                                        <template v-if="order.is_return == false">
                                            <div class="container__Hsummary">{{ order.passengers }}</div>
                                        </template>
                                        <template v-else>
                                            <div style="margin-bottom: 56px;" class="container__Hsummary">{{ order.passengers }}</div>
                                        </template>
                                        <template v-if="translateStatusIntoShorter(order.status) == 'Отмена' && order.comment">
                                            <div class="container__buttonsMenuOrdHis">
                                                <HoverIcon :key="reloadMark">
                                                    <template v-slot:hoverItem>
                                                        <span style="margin-left: 10px;" class="buttonsMenu__status">{{ translateStatusIntoShorter(order.status) }}</span>
                                                    </template>
                                                    <template v-slot:hoverText>
                                                        Причина отказа: {{ order.comment }}
                                                    </template>
                                                </HoverIcon>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="container__buttonsMenuOrdHis">
                                                <span style="margin-left: 10px;" class="buttonsMenu__status">{{ translateStatusIntoShorter(order.status) }}</span>
                                            </div>
                                        </template>
                                    </div>
                                    <div class="underline__history"></div>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex" id="in_pipeline_block" style=" width: 100%; display: none; color: #747474;">
                    <div class="flex-item item_6" style="padding-left: 10px; flex-grow: 6;">
                        <div
                            style="flex-direction: row; display: flex; text-align: left; font-weight: 400; font-size: 12px; line-height: 16px; margin-bottom: 10px; padding: 15px;">
                            <div style="width: 5%;">No / Время</div>
                            <div style="width: 15%;">Когда</div>
                            <div style="width: 30%;">Откуда/Куда</div>
                            <div style="width: 30%;">Пациент/Транспорт</div>
                            <div style="width: 5%; text-align: center;">Кол-во</div>
                        </div>
                        <div v-if="!has_loaded_once" class="loading_text">
                            Данные загружаются, пожалуйста, подождите
                        </div>
                        <div v-else id="processed_orders">
                            <div v-for="order in old_orders" :key="'processed_orders_element'+order.id" :id="'processed_orders_element'+order.id">
                                <span class="superviser__history_item">
                                    <!--{{ order.comment }}-->
                                    <div class="container__history">
                                        <div class="container__itemID">
                                            <template v-if="order.is_return == false">
                                                <div style='padding-bottom: 6px;' class="itemID">{{ order.id }}</div>
                                                <div class="itemID__time">{{ order.time }}</div>
                                            </template>
                                            <template v-else>
                                                <div style='padding-bottom: 6px;' class="itemID">{{ order.id }}</div>
                                                <div style='padding-bottom: 28px;' class="itemID__time">{{ order.time }}</div>
                                            </template>
                                        </div>
                                        <div class="container__date">
                                            <template v-if="order.is_return == false">
                                                <div style='padding-bottom: 28px;' class="date__item">{{ order.datetime_from }}</div>
                                            </template>
                                            <template v-else-if="order.is_wait == true">
                                                <div style='padding-bottom: 56px;' class="date__item">{{ order.datetime_from }}</div>
                                            </template>
                                            <template v-else>
                                                <div style='padding-bottom: 34px;' class="date__item">{{ order.datetime_from }}</div>
                                                <div class="date__item">{{ order.datetime_to }}</div>
                                            </template>
                                        </div>
                                        <div class="container__place">
                                            <template v-if="order.is_return == false">
                                                <div style='padding-bottom: 6px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_r.svg"><span class="place__text">{{ order.place_from }}</span></div>
                                                <div style='padding-bottom: 6px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_r.svg"><span class="place__text">{{ order.place_to }}</span></div>
                                            </template>
                                            <template v-else>
                                                <div style='padding-bottom: 6px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_r.svg"><span class="place__text">{{ order.place_from }}</span></div>
                                                <div style='padding-bottom: 6px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_r.svg"><span class="place__text">{{ order.place_to }}</span></div>
                                                <div style='padding-bottom: 0px;' class="place__adress"><img class="img_history" src="../assets/IMGS/SVG/arrow_green_l.svg"><span class="place__text">{{ order.place_from }}</span></div>
                                            </template>
                                        </div>
                                        <div class="container__patientHistoryOrdHis">
                                            <template v-if="order.is_return == false">
                                                <div style='padding-bottom: 6px;' class="patient__item">
                                                    <img v-if="order.is_invalid" style='margin-right: 10px;margin-left:3px;' class="green-img" src="../assets/IMGS/SVG/invalidPeople.svg">
                                                    <img v-if="order.is_child" style='margin-right: 10px;' class="green-img" src="../assets/IMGS/SVG/child.svg">
                                                    <img v-if="order.is_pregnant" style='margin-right: 10px;' class="green-img" src="../assets/IMGS/SVG/pregnantPeople.svg">
                                                    {{ order.patient_info }}
                                                </div>
                                                <div class="patient__item"><img class="green-img" src="../assets/IMGS/SVG/car.svg">{{ order.transport }}</div>
                                            </template>
                                            <template v-else>
                                                <div style='padding-bottom: 6px;' class="patient__item">
                                                    <img v-if="order.is_invalid" style='margin-right: 10px;margin-left:3px;' class="green-img" src="../assets/IMGS/SVG/invalidPeople.svg">
                                                    <img v-if="order.is_child" style='margin-right: 10px;' class="green-img" src="../assets/IMGS/SVG/child.svg">
                                                    <img v-if="order.is_pregnant" style='margin-right: 10px;' class="green-img" src="../assets/IMGS/SVG/pregnantPeople.svg">
                                                    {{ order.patient_info }}
                                                </div>
                                                <div style='padding-bottom: 28px;' class="patient__item"><img class="green-img" src="../assets/IMGS/SVG/car.svg">{{ order.transport }}</div>
                                            </template>
                                        </div>
                                        <template v-if="order.is_return == false">
                                            <div class="container__Hsummary">{{ order.passengers }}</div>
                                        </template>
                                        <template v-else>
                                            <div style="margin-bottom: 56px;" class="container__Hsummary">{{ order.passengers }}</div>
                                        </template>
                                        <template v-if="translateStatusIntoShorter(order.status) == 'Отмена' && order.comment">
                                            <div class="container__buttonsMenuOrdHis">
                                                <HoverIcon :key="reloadMark">
                                                    <template v-slot:hoverItem>
                                                        <span style="margin-left: 10px;" class="buttonsMenu__status">{{ translateStatusIntoShorter(order.status) }}</span>
                                                    </template>
                                                    <template v-slot:hoverText>
                                                        Причина отказа: {{ order.comment }}
                                                    </template>
                                                </HoverIcon>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="container__buttonsMenuOrdHis">
                                                <span style="margin-left: 10px;" class="buttonsMenu__status">{{ translateStatusIntoShorter(order.status) }}</span>
                                            </div>
                                        </template>
                                    </div>
                                    <div class="underline__history"></div>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-item item_2_space item_space_border_right" style="min-width: 5vw;max-width: 5vw;"></div>
    </div>
</div>
</template>

<script>
import $ from 'jquery';
import tools from '@/assets/js/tools.js';
import HoverIcon from './HoverInfoComponent.vue';

var non_processed_orders = [];
var orders_in_progress = [];
var status_str_to_num = {"Любой" : -1, "Выполнен" : 5, "Отмена" : 8, "Отказ" : 9};

export default {
    name: 'OrderHistory',
    el: '#order_history_page',
    components: {
        'HoverIcon': HoverIcon
    },
    data() {
      return {
        new_orders: non_processed_orders,
        old_orders: orders_in_progress,
        translateStatusIntoShorter: tools.translateStatusIntoShorter,
        getNowDate: tools.getNowDate,
        setNowDay: tools.setNowDay,
        setNowMonth: tools.setNowMonth,
        setLastWeek: tools.setLastWeek,
        setToDefault: tools.setToDefault,
        tools: tools,
        has_loaded_once: false,
        visibleFilters: true,
        reloadMark: 0,
      };
    },
    mounted() {
        var vm = this;
        tools.addAutocompletion('search_adress', "addresses")
        document.getElementById("non_processed_button").onclick = (function() {
            vm.reloadMark += 1;
            let new_width = $("#nowYearRequests").position().left - $("#non_processed_button").position().left;
            document.getElementById("child").animate([
              { marginLeft: document.getElementById("child").style.marginLeft, width: document.getElementById("child").style.width },
              { marginLeft: "0px", width: new_width }
            ], {
              duration: 200,
            });
            $("#child").css("margin-left", 0);
            $("#child").css("width", new_width);
            document.getElementById("non_processed_block").style.display = "flex";
            document.getElementById("in_pipeline_block").style.display = "none";
            document.getElementById("non_processed_button").style.cursor = "default";
            document.getElementById("in_pipeline_button").style.cursor = "pointer";
            $("#non_processed_button").addClass("focused");
            $("#in_pipeline_button").removeClass("focused");
        });

        document.getElementById("in_pipeline_button").onclick = (function() {
            vm.reloadMark += 1;
            let delta_x = $("#in_pipeline_button").position().left - $("#non_processed_button").position().left;
            let new_width = $("#archiveRequests").position().left - $("#in_pipeline_button").position().left + $("#archiveRequests").outerWidth() + parseInt($("#archiveRequests").css("margin-left"));
            document.getElementById("child").animate([
                { marginLeft: document.getElementById("child").style.marginLeft, width: document.getElementById("child").style.width },
                { marginLeft: delta_x, width: new_width }
            ], {
                duration: 200,
            });
            $("#child").css("margin-left", delta_x);
            $("#child").css("width", new_width);
            document.getElementById("non_processed_block").style.display = "none";
            document.getElementById("in_pipeline_block").style.display = "flex";
            document.getElementById("non_processed_button").style.cursor = "pointer";
            document.getElementById("in_pipeline_button").style.cursor = "default";
            $("#non_processed_button").removeClass("focused");
            $("#in_pipeline_button").addClass("focused");
        });
        $("#non_processed_button").click();
        this.reRender();
        setInterval(() => {
            this.reRender();
        }, 5000);
    },
    updated() {
        function setStatusClass(){
            const allButtons = document.querySelectorAll('.buttonsMenu__status');
            allButtons.forEach(element => {
                if (element.textContent === 'Отказ' || element.textContent === 'Отмена') {
                    element.classList.remove('success')
                    element.classList.add('canceled')
                } else {
                    element.classList.remove('canceled')
                    element.classList.add('success')
                }
            });
        }
        setStatusClass();
    },
    methods: {
        reFiltering() {
            this.setToDefault()
            this.reRender();
        },
        flexFilters(){
            if (this.visibleFilters === true) {
                $("#filter__time").css("display", 'none');
                $("#filter__type").css("display", 'none');
                $("#filter__patient").css("display", 'none');
                $("#filter__region").css("display", 'none');
                $("#filter__adress").css("display", 'none');
                $("#fliter__status").css("display", 'none');
                $("#superviser__control").css("width", '50px');
                $("#superviser__control").css("min-width", '50px');
                $("#filter__head").css("width", '28px')
                $("#filter_zone_item").css("opacity", '0');
                $("#filter_zone_item").css("display", 'none')
                this.visibleFilters = false;
            } else if (this.visibleFilters === false) {
                $("#filter__time").css("display", 'flex');
                $("#filter__type").css("display", 'flex');
                $("#filter__patient").css("display", 'flex');
                $("#filter__region").css("display", 'flex');
                $("#filter__adress").css("display", 'flex');
                $("#fliter__status").css("display", 'flex');
                $("#superviser__control").css("width", '256px');
                $("#superviser__control").css("min-width", '256px');
                $("#filter__head").css("width", '234px')
                $("#filter_zone_item").css("opacity", '1');
                $("#filter_zone_item").css("display", 'flex')
                this.visibleFilters = true;
            }
        },
        reRender(ev) {
            if (ev) {
                // no propagation
                if (ev.explicitOriginalTarget == ev.target) {
                    return
                }
            }
            var vm = this;
            vm.flexFilters();
            vm.flexFilters();
            const dateFirst = document.getElementById("first__date");
            const dateSecond = document.getElementById("second__date");
            const timeFirst = document.getElementById("first__time");
            const timeSecond = document.getElementById("second__time");

            function formatDate(date, time, if_first) {
                var current_date;
                var current_time;
                if (date.value == "") {
                    current_date = if_first ? '1970-01-01' : '2970-01-01';
                }
                else {
                    current_date = date.value;
                }
                if (time.value == "") {
                    current_time = if_first ? '00:00' : '23:59';
                }
                else {
                    current_time = time.value;
                }
                var dateTmp = new Date(`${current_date}T${current_time}`);
                var formattedDate = dateTmp.toLocaleString("sv-SE", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false
                }).replace(",", "").replace(/\//g, "-");
                return formattedDate;
                // Output: "2023-02-02 12:30"
            }
            var formattedDateFirst = formatDate(dateFirst, timeFirst, true);
            var formattedDateSecond = formatDate(dateSecond, timeSecond, false);
            var typeService = '';
            if (document.getElementById('veh__check_1').checked) {
                if (document.getElementById('type__check_1').checked) {
                    typeService += '0';
                }
                else {
                    if (document.getElementById('type__check_2').checked) {
                        typeService += '12';
                    }
                    if (document.getElementById('type__check_3').checked) {
                        typeService += '13';
                    }
                    if (document.getElementById('type__check_4').checked) {
                        typeService += '14';
                    }
                }
            }
            else if (document.getElementById('veh__check_2').checked) {
                typeService += '41';
            }
            else if (document.getElementById('veh__check_3').checked) {
                typeService += '21';
            }
            else if (document.getElementById('veh__check_4').checked) {
                typeService += '31';
            }
            else {
                typeService += '0';
            }

            var typePatient = "";
            if (document.getElementById('patient__check_1').checked) {
                typePatient += '1';
            }
            if (document.getElementById('patient__check_2').checked) {
                typePatient += '2'
            }
            if (document.getElementById('patient__check_3').checked) {
                typePatient += '3'
            }
            if (typePatient == "") {
                typePatient = "0";
            }
            var address_filter = document.getElementById('search_adress').value;
            var status_filter = status_str_to_num[document.getElementById("order_status").innerText];
            $.ajax({
                type: "GET",
                xhrFields: { withCredentials: true },
                url: global.BACKEND_URL + `/order_history/getOrderHistory?status=${status_filter}&dateStart=${formattedDateFirst}`
                    + `&dateEnd=${formattedDateSecond}&typeService=${typeService}&typePatient=${typePatient}`
                    + `&myRegion=${document.getElementById("toggle_region").checked}&address=${address_filter}`,

                success: function (data) {
                    vm.has_loaded_once = true;
                    non_processed_orders = [];
                    orders_in_progress = [];
                    data['thisYear'].forEach(singular_order => {
                        non_processed_orders = non_processed_orders.concat(
                            [{
                                "id": singular_order["idOrder"],
                                "time": singular_order["orderDate"],
                                "datetime_from": singular_order["orderDateStart"],
                                "datetime_to": singular_order["orderDateBack"],
                                "place_from": singular_order["regionFrom"] + ", " + singular_order["addressStart"],
                                "place_to": singular_order["regionTo"] + ", " + singular_order["addressFinish"],
                                "passengers": singular_order["numPassenger"],
                                "patient_info": ((singular_order["escort"] == "Не требуется") ? "Сопровождение: нет" : singular_order["escort"]),
                                "transport": singular_order["transport"],
                                "is_return": singular_order["isReturn"] == "true",
                                "is_wait": singular_order["isWait"] == "true",
                                "status": singular_order["status"],
                                "is_child" : singular_order["isChild"] == "true",
                                "is_pregnant" : singular_order["isPregnant"] == "true",
                                "is_invalid" : singular_order["isInvalid"] == "true",
                                "comment" : singular_order["comment"]
                            }]
                        )
                    })
                    data['archive'].forEach(singular_order => {
                        orders_in_progress = orders_in_progress.concat(
                            [{
                                "id": singular_order["idOrder"],
                                "time": singular_order["orderDate"],
                                "datetime_from": singular_order["orderDateStart"],
                                "datetime_to": singular_order["orderDateBack"],
                                "place_from": singular_order["regionFrom"] + ", " + singular_order["addressStart"],
                                "place_to": singular_order["regionTo"] + ", " + singular_order["addressFinish"],
                                "passengers": singular_order["numPassenger"],
                                "patient_info": ((singular_order["escort"] == "Не требуется") ? "Сопровождение: нет" : singular_order["escort"]),
                                "transport": singular_order["transport"],
                                "is_return": singular_order["isReturn"] == "true",
                                "is_wait": singular_order["isWait"] == "true",
                                "status": singular_order["status"],
                                "is_child" : singular_order["isChild"] == "true",
                                "is_pregnant" : singular_order["isPregnant"] == "true",
                                "is_invalid" : singular_order["isInvalid"] == "true",
                                "comment" : singular_order["comment"]
                            }]
                        )
                    })
                    vm.new_orders = non_processed_orders;
                    vm.old_orders = orders_in_progress;
                    $("#nowYearRequests").text(vm.new_orders.length);
                    $("#archiveRequests").text(vm.old_orders.length);
                },
                error: function () { console.log("Not success :(") },
                dataType: "json",
                contentType: "application/json"
            })
            this.currentKey += 1;
        },
    }
}
</script>

<style lang="css" scoped src="@/assets/css/dispatcher_orders.css"></style>
